import React from 'react';
import PropTypes from 'prop-types';
import { Box, FormControlLabel, Radio, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';

export const SingleSelectTile = (props) => {
  const {
    id,
    value,
    label,
    checked,
    imageUrl,
    selectedUrl,
    loading,
    onToggle,
  } = props;

  const theme = useTheme();

  const handleToggle = () => {
    if (loading) return;
    onToggle(id);
  };

  return (
    <FormControlLabel
      value={value}
      key={id}
      control={
        <Radio
          checked={Boolean(checked)}
          onChange={handleToggle}
          disabled={loading}
          sx={visuallyHidden}
          inputProps={{ 'aria-label': label }}
        />
      }
      disabled={loading}
      sx={{ margin: '20px 10px', position: 'relative' }}
      label={
        <>
          <Box
            component="img"
            src={checked ? selectedUrl : imageUrl}
            alt=""
            aria-hidden="true"
            sx={{
              maxWidth: '100%',
              borderRadius: '5px',
              border: '1px solid' + theme.palette.common.dark,
              background: 'rgba(38, 44, 42, 0.12)',
              width: '200px',
              height: '200px',
              [theme.breakpoints.down('sm')]: {
                width: '125px',
                height: '125px'
              },
            }}
          />

          <Typography
            component="div"
            aria-hidden="true"
            sx={{
              textAlign: 'center',
              color: theme.palette.common.dark,
              fontWeight: 'bold',
            }}
          >
            {label}
          </Typography>
        </>
      }
    />
  );
};

SingleSelectTile.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  checked: PropTypes.bool,
  imageUrl: PropTypes.string,
  selectedUrl: PropTypes.string,
  onToggle: PropTypes.func,
};

export default SingleSelectTile;
